import React, { useRef } from "react";
import {
  Chart,
  Series,
  Tooltip,
  Legend,
  ArgumentAxis,
  ValueAxis,
  Label,
  Grid,
  Point,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const EclGapDistribution = ({ data, palette }) => {
  const chartRef = useRef(null);

  const customizeTooltip = (info) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${info.argumentText}</div>
          <div>Fifo lines : ${info.value}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="ECL gap distribution"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="gapDistributionChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            name="Fifo lines number by ECL gap (percent)"
            valueField="count"
            argumentField="interval"
            type="line"
          >
            <Point visible={true} size={10} symbol="circle" />
          </Series>

          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="none"
              displayMode="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>

          <ValueAxis>
            <Label />
            <Grid visible={true} />
          </ValueAxis>

          <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
          <Legend
            visible={true}
            verticalAlignment="bottom"
            horizontalAlignment="center"
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default EclGapDistribution;
